import { propsEvalOrReturn } from './propsEvalOrReturn.js';

function ifRtl(truthyValue, falsyValue) {
  return function (props) {
    var _props$theme;

    // sometimes in tests we are lazy and don't pass theme
    // in some edge cases this may occur in real life too
    var isThemeRtl = !!(props !== null && props !== void 0 && (_props$theme = props.theme) !== null && _props$theme !== void 0 && _props$theme.isRtl);
    if (isThemeRtl) return propsEvalOrReturn(truthyValue, props);
    return propsEvalOrReturn(falsyValue, props);
  };
}

export { ifRtl };
